/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid, MenuItem } from '@material-ui/core';
import {
  getClassroomLink,
} from '@webapps/business';
import {
  Button,
  useMutation,
  useRouter,
  useToast
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useState, useEffect } from 'react';
import InfoName from './Components/InfoName';
import InfoLinkpick from './Components/InfoLinkpick';
import StudentsTrack from './Components/StudentsTrack';
import StudentDetail from './Components/StudentDetail';
import { ROUTES_PATH } from 'config/constants';


const ClassesShare = () => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);

  const { params, push } = useRouter();
  const { link } = params;
  const { addToast } = useToast();

  const [selectedStudent, setSelectedStudent] = useState(null);

  const {
    data: classroom,
    error,
    mutateAsync: mutateClassroomLink,
  } = useMutation(getClassroomLink);
  
  useEffect(() => {
    if (link) {
      mutateClassroomLink({ link });
    }
  }
  , [link]);

  useEffect(() => {
    if(classroom?.students.length > 0 && window.innerWidth > 1023) {
      setSelectedStudent(classroom.students[0]);
    }
  }, [classroom]);

  useEffect(() => {
    if (error) {
      addToast({
        status: 'error',
        message: error?.response?.data?.description || "Une erreur est survenue",
      });
      push(ROUTES_PATH.SIGN_IN);
    }
  }, [error]);
  
  return (
    <Grid xs={12} style={{display: "flex", minHeight: '100vh', flexWrap: 'wrap'}}>
      {classroom?.id && (
        <>
          <Grid xs={12} md={7}>
            <div className={classes.leftHeader}>
              <InfoName info={classroom} />
            </div>
            <div className={classes.leftContainer}>
              <StudentsTrack students={classroom?.students} setSelectedStudent={setSelectedStudent}/>
            </div>
          </Grid>
          <Grid xs={12} md={5}>
            <div className={classes.rightHeader}>
              <InfoLinkpick />
            </div>
            <div className={classes.rightContainer}>
              {selectedStudent && <StudentDetail student={selectedStudent} setSelectedStudent={setSelectedStudent} />}
            </div>
          </Grid>
        </>
      )}
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  rightHeader: {
    backgroundColor: "#0060F9",
    height: "178px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    textAlign: "center",
  },
  leftContainer: {
    background: "white",
    padding: "20px",
    height: "calc(100vh - 178px)",
    '@media (max-width:1023px)': {
      height: "calc(100vh - 356px)",
    },
    overflowY: "scroll",
  },
  rightContainer: {
    '@media (min-width:1023px)': {
      minHeight: "calc(100vh - 178px)",
    },
  },
});

export default ClassesShare;
